import React, { useEffect, useRef, useState } from 'react';
import { Image, Box, Table, TableToolbar, Text, TextButton, EmptyState } from '@wix/design-system';
import { sdk, STATIC_MEDIA_URL } from '@wix/image-kit';
import { HELP_LINKS, USED_FILES_PAGE_SIZE } from '../../constants';
import { withFileUsedParam } from '../../utils';
import styles from './styles.scss';
import { SkeletonRowLoader } from './SkeletonRowLoader';
export const FilesInUseContent = _ref => {
  let {
    usedFiles,
    usedFilesCount,
    hasMore,
    isLoadError,
    formatMessage,
    formatDate,
    loadMoreFiles
  } = _ref;
  const containerRef = useRef(null);
  const [container, setContainer] = useState(null);
  useEffect(() => {
    setContainer(containerRef);
  }, []);
  const LazyLoadError = () => /*#__PURE__*/React.createElement(EmptyState, {
    theme: "page-no-border",
    title: formatMessage({
      id: 'files-manager.delete-permanently-modal-loading-error-message3-title'
    }),
    subtitle: formatMessage({
      id: 'files-manager.delete-permanently-modal-loading-error-message3-text'
    })
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: styles.container
  }, /*#__PURE__*/React.createElement(Table, {
    data: usedFiles,
    itemsPerPage: USED_FILES_PAGE_SIZE,
    hasMore: hasMore,
    loadMore: loadMoreFiles,
    selectionDisabled: true,
    infiniteScroll: true,
    scrollElement: container && container.current,
    loader: isLoadError ? /*#__PURE__*/React.createElement(LazyLoadError, null) : /*#__PURE__*/React.createElement(SkeletonRowLoader, null),
    columns: [{
      title: '',
      render: file => /*#__PURE__*/React.createElement(Image, {
        src: withFileUsedParam(sdk.getScaleToFillImageURL(file.thumbnailUrl.replace(STATIC_MEDIA_URL, ''), 1000, 1000, 36, 36)),
        width: "36px",
        height: "36px"
      }),
      width: 36
    }, {
      title: '',
      render: file => /*#__PURE__*/React.createElement(Box, {
        direction: "vertical"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small"
      }, file.displayName), /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin"
      }, formatMessage({
        id: 'files-manager.delete-permanently-modal-confirmation.file-last-viewed'
      }, {
        viewedDate: formatDate(new Date(file.lastUsedDate), {
          month: 'short',
          day: 'numeric'
        })
      })))
    }]
  }, /*#__PURE__*/React.createElement(TableToolbar, null, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    marginBottom: "small"
  }, /*#__PURE__*/React.createElement(Text, null, formatMessage({
    id: 'files-manager.delete-permanently-modal-confirmation.text'
  }, {
    itemsCount: usedFilesCount
  }), "\xA0", /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    target: "_blank",
    href: HELP_LINKS.DELETE_MODAL,
    dataHook: "file-awareness-delete-modal-learn-more"
  }, formatMessage({
    id: 'files-manager.delete-permanently-modal-confirmation.learn_more'
  })))), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, formatMessage({
    id: 'files-manager.delete-permanently-modal-confirmation.label'
  })))), /*#__PURE__*/React.createElement(Table.Content, {
    titleBarVisible: false
  })));
};
//# sourceMappingURL=FilesInUseContent.js.map